import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WirelessSecureAccountStore {
  private readonly entry = signal<{ orderNumber: string; account: any } | null>(null);

  setFromResponse(orderNumber: string, response: any): void {
    const account = response?.ResponseHeader?.ProductResponse?.find(
      (p: any) => p.Type?.toLowerCase() === 'wireless'
    ) ?? null;
    this.entry.set(account ? { orderNumber, account } : null);
  }

  getAccount(orderNumber: string): any {
    const current = this.entry();
    return current?.orderNumber === orderNumber ? current.account : null;
  }

  clear(): void {
    this.entry.set(null);
  }
}
